import { QueryClient, QueryClientConfig } from '@tanstack/react-query';
import { queryPolicies } from './queryPolicies.js';

/**
 * Configuration for the React Query client with optimized defaults
 * for the CRM application
 */
const queryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      // Enable automatic deduplication of identical requests
      staleTime: queryPolicies.default.staleTime,
      gcTime: queryPolicies.default.gcTime,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // This should deduplicate identical queries automatically
      notifyOnChangeProps: 'all'
    }
  }
};

export const queryClient = new QueryClient(queryClientConfig);
